// extracted by mini-css-extract-plugin
module.exports = {"read-more-message-hide":"ReadMore_read-more-message-hide__pepzT","read-more-button":"ReadMore_read-more-button__RHdxR","less-pdp-msg":"ReadMore_less-pdp-msg__dkkxe"};